import type { SVGProps } from 'react';

const SvgEditLocationAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M13.95 13H9V8.05l5.61-5.61A8.2 8.2 0 0 0 12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-1.01-.16-1.94-.45-2.8zM11 11h2.12l6.16-6.16-2.12-2.12L11 8.88zM19.29.59l-1.42 1.42 2.12 2.12 1.42-1.42z" />
  </svg>
);
export default SvgEditLocationAlt;
